/**
 * @ngdoc service
 * @name bookingCalendar
 *
 * @requires GeneralOptions
 * @requires AppService
 * @requires responsive
 *
 * @description
 * Serves data required by some calendar components during the booking phase.
 */
class BookingCalendar {
    constructor(GeneralOptions, AppService, responsive) {
        'ngInject';

        this.GeneralOptions = GeneralOptions;
        this.AppService = AppService;
        this.responsive = responsive;
    }

    getTimeRangeLength() {
        const calendarSizeToRangeMap = Object.assign({}, this.GeneralOptions.calendarDaysByScreenWidth);

        // Default fallback time range.
        let fallbackTimeRange = 7;

        // Override default configuration if calendar was opened inside modal dialog.
        if (this.AppService.isModalOpen()) {
            fallbackTimeRange = calendarSizeToRangeMap.lg = 5;
        }

        const currentSize = this.responsive.getCurrentSize();

        // Get number of days to be showed basing on the current window size.
        return calendarSizeToRangeMap[currentSize] || fallbackTimeRange;
    }
}

angular
    .module('BBPublicBooking')
    .service('bookingCalendar', BookingCalendar);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/_services/booking_calendar.service.js